module.exports = __webpack_public_path__ + "img/Importancia_software_gestao_obras.1a807fe3.jpg";